var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-20"},[_c('div',[_vm._v("404 找不到页面了")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.replace('/')}}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }